<template>
  <div class="KeywordSearchField">

    <input v-model="searchTerm" autocomplete="off" @keydown.enter.prevent="autocompleteOpen = false" @keydown.esc.prevent="autocompleteOpen = false" type="search" name="keyword-search-field" id="keyword-search-field" placeholder="Search by keyword..."/>
    <div class="Autocomplete" v-if="autocompleteOpen && searchTerm.length >= 3 && autocompleteResults.length > 0">
      <h4>Suggested Searches</h4>
      <ul>
        <li v-for="(item,index) in autocompleteResults" @click="setSearchTerm(item)" :key="'acr-'+index">{{ item.title }}</li>
      </ul>
    </div>
    <svg width="20px" height="19px" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs></defs>
        <g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="EDTools-unfiltered" transform="translate(-538.000000, -413.000000)" fill="#333333" fill-rule="nonzero">
                <g id="search" transform="translate(538.000000, 413.000000)">
                    <path d="M20,17.753125 L13.3939394,11.28125 C15.5757576,8.55 15.3939394,4.571875 12.7878788,2.078125 C11.4545455,0.7125 9.63636364,0 7.75757576,0 C5.87878788,0 4.06060606,0.7125 2.66666667,2.078125 C-0.121212121,4.809375 -0.121212121,9.2625 2.66666667,11.99375 C4,13.3 5.81818182,14.071875 7.6969697,14.071875 C9.27272727,14.071875 10.7878788,13.5375 12.0606061,12.5875 L18.7272727,19 L20,17.753125 Z M4,10.6875 C1.93939394,8.66875 1.93939394,5.34375 4,3.325 C4.96969697,2.315625 6.3030303,1.78125 7.75757576,1.78125 C9.21212121,1.78125 10.5454545,2.315625 11.5151515,3.325 C13.5757576,5.34375 13.5757576,8.66875 11.5151515,10.6875 C10.4848485,11.696875 9.15151515,12.23125 7.75757576,12.23125 C6.36363636,12.23125 4.96969697,11.696875 4,10.6875 Z" id="Shape"></path>
                </g>
            </g>
        </g>
    </svg>
  </div>
</template>

<script>
import debounce from 'tiny-debounce'

export default {
  name: 'KeywordSearchField',
  data() {
    return {
      searchTerm: '',
      autocompleteOpen: false,
      initial: null,
      autocompleteResults: []
    }
  },
  props: {
    //
  },
  mounted: function () {
    this.listenFor('initial-filters-q', arg => {
      this.initial = arg
      this.searchTerm = arg
    })

    this.listenFor('close-autocomplete', arg => {
      this.autocompleteOpen = false
    })
  },
  watch: {
    searchTerm: debounce(function (value) {
      // Trigger autocomplete on normal query, but not on initial.
      if((value !== this.initial)) {
        // Added these lines in this condition to prevent double query on page load.
        // console.log("debounce resolved!")
        this.$store.commit('updateSearchTerm', value)
        //

        if (value !== '' && value.length >= 3) { // autocomplete trigger character limit
          this.autocompleteQuery()
        }
      }
    }, 250)
  },
  // computed: {
  //   searchTerm: {
  //     get () {
  //       return this.$store.state.searchTerm
  //     },
  //     set (value) {
  //       this.$store.commit('updateSearchTerm', value)
  //     }
  //   }
  // },
  methods: {
    setSearchTerm: function (item) {
      // This is for autocomplete.

      // This is the old way.
      // this.searchTerm = item.title
      // this.$store.commit('updateSearchTerm', this.searchTerm)

      window.location.assign(item.url)

    },
    autocompleteQuery: function () {
      var $this = this
      this.autocompleteOpen = true
      this.$store.commit('updateCurrentPage', 1)

      var api = 'https://search-api.swiftype.com/api/v1/public/engines/suggest?engine_key=bBSzVx-LA9Z4yYTf6W-S'

        var data = {
        "q": this.searchTerm,
        "per_page" : "5",
        "page" : "1"
        // uncomment if this needs to respect filters; these methods are in Search.vue
        // "filters": {
        //   "page": {
        //     "type": $this.getActiveTypeFilters(),
        //     "topics": $this.getActiveTopicFilters(),
        //     "grades": $this.getActiveGradeFilters(),
        //     "key_person": $this.getActivePersonFilters(),
        //     "states": $this.getActiveStateFilters(),
        //     "centuries": $this.getActiveCenturyFilters(),
        //   }
        // },
      }


      // if (this.dateFilterFrom !== '' || this.dateFilterFrom !== '') {
      //   data.filters.page.date_historical = {
      //     'type': 'range',
      //     'from': this.dateFilterFrom + '-01-01T00:00:00-0500',
      //     'to': this.dateFilterTo + '-01-01T00:00:00-0500',
      //   }
      // } else {
      //   delete data.filters.page.date_historical
      // }

      var headers = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json'
        }
      }


      this.axios.post(api, data, headers)
      .then(function (response) {
        var dataPackage = {}
        dataPackage.currentCount = response.data.record_count
        dataPackage.totalCount = response.data.info.page.total_result_count
        $this.autocompleteResults = response.data.records.page
      }).catch(function (error) {
        // (error);
      })
    }
  }
};
</script>

<style scoped lang="scss">
.KeywordSearchField {
  max-width: 440px;
  position: relative;
  display: inline-block;
  background: white;
  margin-left: 10px;
  width: 80%;
  position: relative;
  @include smx { width: calc(100% - 145px); margin-right: 30px; }
  @include tiny { width: calc(100% - 15px); margin-left: 0; margin-right: 15px; margin-top: 8px;}

  input {
    display: block;
    width: 100%;
    background: transparent;
    border: none;
    outline: none;
    appearance: none;
    font-size: 18px;
    height: 24px;
    padding: 18px 10px;
  }

  svg {
    position: absolute;
    top: 8px;
    right: 8px;
  }

}

.Autocomplete {
  position: absolute;
  background: white;
  top: 40px;
  padding-left: 16px;
  left: -1px;
  border-left: 1px solid #EDEFF1;
  border-right: 1px solid #EDEFF1;
  border-bottom: 1px solid #EDEFF1;
  width: 442px;
  z-index: 999;

  li {
    padding-left: 24px;
    padding-bottom: 20px;
    font-size: 18px;
    cursor: pointer;
  }

  h4 {
    text-transform: uppercase;
    font-size: 16px;
    padding-bottom: 24px;
    padding-top: 12px;
  }
}
</style>
